import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useObservableState } from 'observable-hooks';
import { map } from 'rxjs/operators';
import { useParams } from 'react-router-dom';
import { INTERNAL_AUDIT_LOGS_INDEX } from '../../../router/routes';
import { useService } from '../../../services/services';
import Audit from '../../../interfaces/audit';
import Group from '../../../components/form/elements/group';
import Text from '../../../components/form/elements/text';
import Form from '../../../components/form';
import HtmlBlock from '../../../components/form/elements/html-block';

export default function ViewAuditLog() {
  const { id } = useParams<{ id: string }>();
  const { auditService } = useService();
  const [body, setBody] = useState([]);
  const [audit] = useObservableState<Audit>(
    () =>
      auditService.show(id).pipe(
        map((audit) => {
          return {
            ...audit,
            created_at: moment(audit.created_at).format('DD.MM.YYYY HH:mm:ss'),
          };
        })
      ),
    null
  );

  useEffect(() => {
    if (audit !== null) {
      setBody([
        Group([
          HtmlBlock('user', <pre>{JSON.stringify(audit.user, null, 1)}</pre>),
          Text('event'),
          Text('created_at'),
          HtmlBlock(
            'auditable',
            <pre>{JSON.stringify(audit.auditable, null, 1)}</pre>
          ),
          HtmlBlock(
            'old_values',
            <pre>{JSON.stringify(audit.old_values, null, 1)}</pre>
          ),
          HtmlBlock(
            'new_values',
            <pre>{JSON.stringify(audit.new_values, null, 1)}</pre>
          ),
          Text('url'),
          Text('ip_address'),
          Text('user_agent'),
        ]),
      ]);
    }
  }, [id, audit]);

  return (
    <Form
      title={
        audit
          ? audit.event.concat(
              audit.user ? audit.user?.name : '',
              ' ',
              audit.created_at
            )
          : null
      }
      backTo={INTERNAL_AUDIT_LOGS_INDEX}
      mode={'view'}
      body={body}
      values={audit}
    />
  );
}
